import { selector } from 'recoil';
import { formMetadataState } from '../';

export const formSchemaState = selector({
	key: 'formSchemaState',
	get: ({ get }) => {
		const { inputs } = get(formMetadataState);
		if (inputs.length > 0) {
			const formSchema = [];
			for (const formItem of inputs) {
				const {
					id,
					name,
					displayName,
					description,
					required,
					readonly,
					idUiTypeNavigation,
					defaultValue,
					setOfValues,
				} = formItem;

				formSchema.push({
					id,
					name,
					placeholder: displayName,
					label: description,
					required,
					disabled: readonly,
					setOfValues,
					defaultValue,
					uiType: idUiTypeNavigation ? idUiTypeNavigation.uiTypeName : null,
					type: formItem.idDataTypeNavigation.dataTypeName,
				});
			}
			return {
				error: null,
				formSchema,
			};
		}
	},
});
